import type { StateCreator } from "zustand";

import type { ZObjectOpportunities } from "../types";

export const objectOpportunitiesSlice: StateCreator<ZObjectOpportunities> = (
  set,
  get,
) => ({
  isExpanded: true,
  toggleExpanded: () => {
    const { opportunities } = get();
    if (opportunities.length === 0) return;
    set(state => ({ isExpanded: !state.isExpanded }));
  },

  opportunities: [],
  updateOpportunityById: (id, opportunity) => {
    set(state => {
      const opportunities = state.opportunities.map(op =>
        op.opportunity_id === id ? { ...op, ...opportunity } : op,
      );

      return { opportunities };
    });
  },
});
